export default {
  guests_pay: 'Asiakkaat maksavat {{amount}} kassalla (viimeisin vaihtokurssi).',
  missing_rate:
    'Valuutalle {{currency}} ei ole vielä vaihtokurssia, joten asiakkaat maksavat {{amount}} muuntamattomana.',
};
